import Swiper from 'swiper';

export default class {
    constructor({
        id,
        prevId,
        nextId,
    }) {
        const el = document.getElementById(id);
        const swiperContainer = el.querySelector('.swiper-container');
        const controlsPrev = document.getElementById(prevId);
        const controlsNext = document.getElementById(nextId);

        const swiper = new Swiper(swiperContainer, {
            init: false,
            autoHeight: true,
            allowTouchMove: false,
            slidesPerView: 1,
            navigation: {
                prevEl: controlsPrev,
                nextEl: controlsNext,
            },
        });

        // Initialize Swiper
        swiper.init();
    }
}
